
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "components/Layout";
import NotFOund from "components/Layout/404";
import Banner from "components/works/Banner";
import Contents from "components/works/Contents";
import { GetServerSidePropsContext } from "next";
async function getServerSideProps(context: GetServerSidePropsContext) {
    const id = context!.params!.id;
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_API}/project/${id}`);
        const { data } = await res.json();
        return {
            props: { data: data },
        };
    }
    catch (error) {
        return {
            props: { data: null },
        };
    }
}
interface props {
    data: IProject;
}
function index({ data }: props) {
    if (data == null) {
        return (<Layout title="404" description="Not Found Anything" image="">
        <NotFOund />
      </Layout>);
    }
    return (<Layout title={data.title} description={data.description} image={data.featuredImage}>
      <Banner data={data}/>
      <Contents data={data}/>
    </Layout>);
}
export default index;

    async function __Next_Translate__getServerSideProps__198fecf4c64__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/works/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__198fecf4c64__ as getServerSideProps }
  